export default "__VITE_ASSET__g5$PdLG$__"